import React, {ChangeEvent, useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {ReactComponent as SeekLogo} from '../../../assets/seek-logo.svg';
import {getUserByUserId, updateUser} from '../../../services/Firebase';
import ErrorComponent from '../../../components/error/Error';
import './CompleteProfile.css';
import {useDispatch, useSelector} from 'react-redux';
import TextInput from '../../../components/textInput/TextInput';
import {LoadScript} from '@react-google-maps/api';
import PlaceInput from '../../signup-form/user-experience-components/PlaceInput';
import PrimaryButton from '../../../components-v2/buttons/PrimaryButton';
import BottomSheet from '../../../components/model/BottomSheet';
import {isMobileDevice, OptionsOfAgeGroup} from '../../../utils/utils';
import useAuthenticatedUsers from '../../../hooks/useAuthenticatedUsers';
import {Mixpanel} from '../../../analytics/Mixpanel';
import {events_action} from '../../../analytics/Events';
import {addUsers} from '../../../store/features/AuthSlice';
import Loader from '../../../components/loader/Loader';

interface IconWithTitleProps {
    icon: string; // You can use any type that represents your icon, e.g., React.ComponentType
    title: string;
    index: number;
    selectedIndex?: number;
    selectOptionHandler: (index: number) => void;
}

const IconWithTitle: React.FC<IconWithTitleProps> = ({
                                                         icon,
                                                         title,
                                                         index,
                                                         selectedIndex,
                                                         selectOptionHandler,
                                                     }) => {
    const isSelected = selectedIndex === index;
    return (
        <div
            onClick={selectOptionHandler.bind(null, index)}
            className={`complete-profile-age-icon-with-title ${
                isSelected ? 'complete-profile-selected-age-icon-with-title' : ''
            }`}>
            <div
                className={`complete-profile-age-row-title ${
                    isSelected ? 'complete-profile-selected-age-row-title' : ''
                }`}>
                {title}
            </div>
        </div>
    );
};

function CompleteProfile() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const userData = useAuthenticatedUsers();
    const user = useSelector((state: any) => state?.auth?.user?.data);
    const [error, setError] = useState<string>('');
    const width =
        user?.name?.split(' ')?.[0]?.length * 18 ||
        userData?.name?.split(' ')?.[0]?.length * 18;
    // const width = (user?.name?.split(' ')?.[0]?.length * 10);
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
    const [showAgePopup, setShowAgePopup] = useState(false);
    const [email, setEmail] = useState<string>(user?.email || '');
    const [age, setAge] = useState<any>(null);
    const [location, setLocation] = useState('');

    const handleEmailChange = (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setEmail(event.target.value?.trim());
    };

    const handleAgeChange = (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setError('');
        setShowAgePopup((prevState) => !prevState);
    };

    const handleSelectPlace = (place: any) => {
        setError('');
        setLocation(place?.description);
        // You can handle the selected place here
    };
    const [selectedIndex, setSelectedIndex] = useState<number>(0);

    const selectOptionHandler = (selectedIndex: number) => {
        setError('');
        setAge(OptionsOfAgeGroup[selectedIndex].value);
        setSelectedIndex(selectedIndex);
        setTimeout(() => setShowAgePopup(false), 1000);
    };

    useEffect(() => {
        try {
            Mixpanel.track('view_complete_your_profile', {
                event_page: 'complete_your_profile',
                event_action: events_action.viewed,
            });
        } catch (e) {
        }
    }, []);



    useEffect(() => {
        if (!isKeyboardOpen && isMobileDevice()) {
            window.scrollTo(0, 0);
        }
        if (!showAgePopup) {
            window.scrollTo(0, 0);
        }
    }, [isKeyboardOpen, showAgePopup]);

    const onCompleteProfileHandler = async () => {
        if (!age) {
            setError('Please Enter age');
            return;
        }
        if (!location) {
            setError('Please Search location');
            return;
        }

        Mixpanel.track('click_submit_details', {
            event_page: 'complete_your_profile',
            event_action: events_action.clicked,
            response: {
                age: age,
                location: location,
                email: email,
            },
        });
        try {
            setLoader(true);
            const updatedUser = await updateUser(userData?.uid, {
                'userPreferences.age': age,
                'userPreferences.location': location,
                email: email,
                isProfileCompleted: true,
            });

            if (updatedUser?.status === 200) {
                setLoader(false);

                try {
                    Mixpanel.identify(userData?.uid);
                    Mixpanel.people.set({
                        $age_group: age,
                        $location: location,
                        $email: email,
                    });
                    Mixpanel.track('click_submit_details_success', {
                        event_page: 'complete_your_profile',
                        event_action: events_action.clicked,
                        age_group: age,
                        location: location,
                        email: email,
                    });
                } catch (error) {
                    console.log('Complete profile error', error);
                }

                getUserByUserId(userData?.uid).then((result: any) => {
                    console.log("result userdata", result);
                    dispatch(addUsers(result.user));
                })


                userData.isProfileCompleted = true;
                userData.email = email;
                window.localStorage.setItem('user', JSON.stringify(userData));
                navigate('/home');

                return;
            }
            throw new Error('Error updating profile');
        } catch (e) {
            setLoader(false);
            try {
                Mixpanel.track('click_submit_details_failure', {
                    event_page: 'complete_your_profile',
                    event_action: events_action.clicked,
                    response: {
                        age: age,
                        location: location,
                        email: email,
                    },
                });
            } catch (e) {
            }
        }
    };

    return (
        <div className={'complete-profile-container'}>
            {loader && <Loader/>}
            {error && (
                <ErrorComponent
                    onClose={setError.bind(null, '')}
                    customStyles={{
                        position: 'fixed',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        top: 10,
                        left: 10,
                        right: 10,
                    }}
                    message={error}
                />
            )}

            <div
                className={'complete-profile-header'}
                style={{width: '80%', marginTop: '32px', marginLeft: '-12px'}}>
                <SeekLogo
                    style={{
                        alignSelf: 'center',
                        width: '100%',
                        marginLeft: '12px',
                        alignItems: 'center',
                    }}
                    width={108}
                    height={44}
                />
            </div>
            <span className={'complete-profile-title'} style={{marginTop: '40px'}}>
				Complete your profile,
			</span>
            <span
                className={'complete-profile-title'}
                style={{
                    marginTop: '-18px',
                    zIndex: 2,
                }}>
				{userData?.name?.split(' ')?.[0].charAt(0)?.toUpperCase() +
                    userData?.name?.split(' ')?.[0]?.slice(1) ||
                    user?.name?.split(' ')?.[0].charAt(0)?.toUpperCase() +
                    user?.name?.split(' ')?.[0]?.slice(1)}
			</span>
            <svg
                style={{marginTop: '-28px', width: `${width}px`, height: '24px'}}
                xmlns='http://www.w3.org/2000/svg'
                width='162'
                height='24'
                viewBox='0 0 162 24'
                fill='none'>
                <g clip-path='url(#clip0_335_5353)'>
                    <mask
                        id='mask0_335_5353'
                        maskUnits='userSpaceOnUse'
                        x='0'
                        y='0'
                        width='162'
                        height='24'>
                        <path
                            d='M160.739 0.246476L0.785645 4.11776L1.26067 23.7449L161.214 19.8736L160.739 0.246476Z'
                            fill='white'
                        />
                    </mask>
                    <g mask='url(#mask0_335_5353)'>
                        <path
                            d='M3.22835 16.1264C1.02912 15.2561 1.33985 14.4182 4.16055 13.6128C6.98125 12.8073 11.6772 12.2202 18.2485 11.8512C19.7033 11.8005 21.1112 11.7603 22.472 11.7305C23.9269 11.6799 25.0183 11.5966 25.7464 11.4806C26.5208 11.4449 28.539 11.3601 31.8007 11.2261C35.2267 11.101 39.298 10.9462 44.0147 10.7615C48.8016 10.6066 53.7645 10.4354 58.9034 10.2478C64.1125 10.0898 68.9815 9.93938 73.5102 9.79638C78.1328 9.63258 81.9809 9.5045 85.0554 9.41212C88.129 9.31975 89.8297 9.28248 90.1588 9.30026C90.345 9.4399 90.8607 9.5067 91.7057 9.50068C92.7137 9.50358 93.5823 9.44705 94.31 9.33113C95.2031 9.22407 96.2469 9.1512 97.444 9.11247C98.7107 9.10345 99.5783 9.13755 100.047 9.21476C100.657 9.17015 101.349 9.12997 102.124 9.09425C102.969 9.08823 103.614 9.05847 104.06 9.00495C104.506 8.95143 104.976 8.93802 105.468 8.96472C106.054 8.97062 106.571 8.94678 107.017 8.89328C108.424 8.94368 110.477 8.96428 113.174 8.95516C115.966 8.9252 119.099 8.88778 122.571 8.84293C126.114 8.82776 129.668 8.78735 133.235 8.72167C136.871 8.68571 140.261 8.63641 143.405 8.57374C146.549 8.51108 149.189 8.44697 151.324 8.38142C153.459 8.31589 154.75 8.25635 155.195 8.20285C156.816 7.97987 158.082 8.15209 158.994 8.71947C159.72 8.78478 160.375 9.00163 160.959 9.36999C160.959 9.36999 160.795 9.45171 160.465 9.61515C160.299 9.7875 159.992 10.0817 159.543 10.4977C159.189 10.8928 158.554 11.1692 157.638 11.3267C156.793 11.514 155.747 11.6775 154.503 11.8173C153.141 12.0283 151.814 12.1636 150.523 12.2232C149.326 12.2619 147.473 12.265 144.964 12.2325C142.548 12.1793 138.747 12.1157 133.564 12.0419C132.296 12.0509 130.995 12.045 129.658 12.0244C128.484 12.0126 127.359 11.9904 126.28 11.9578C125.365 11.9341 124.567 11.9298 123.887 11.9446C123.3 11.9388 122.913 11.9566 122.725 11.9983C122.279 12.0517 121.469 12.0726 120.297 12.0608C119.288 12.058 118.056 12.0818 116.602 12.1324C115.523 12.0999 113.975 12.0807 111.957 12.0749C109.939 12.0692 107.84 12.0589 105.659 12.0442C103.547 12.0593 101.646 12.0728 99.9575 12.0849C98.3616 12.0761 97.4696 12.0925 97.2821 12.1341C96.9301 12.1668 96.4962 12.1951 95.9796 12.2189C95.5334 12.2724 94.9934 12.2561 94.3619 12.17C94.1741 12.0304 93.7289 11.9933 93.0249 12.0587C92.4854 12.133 92.2153 12.1702 92.2153 12.1702C91.4632 12.3366 88.2483 12.4602 82.57 12.5409C79.919 12.6303 75.9413 12.7643 70.6382 12.943C65.4053 13.1515 59.574 13.3792 53.1443 13.6264C46.8788 13.8825 40.6954 14.143 34.594 14.4079C28.5867 14.6521 23.3889 14.8753 19.0005 15.0777C14.6823 15.3099 11.9362 15.5107 10.7619 15.6801C8.3197 16.0398 6.66436 16.2479 5.79597 16.3045C4.83358 16.3818 3.97771 16.3224 3.22835 16.1264Z'
                            fill='#FB8500'
                        />
                    </g>
                </g>
                <defs>
                    <clipPath id='clip0_335_5353'>
                        <rect
                            width='160'
                            height='20'
                            fill='white'
                            transform='translate(0.78125 3.93848) rotate(-1.38644)'
                        />
                    </clipPath>
                </defs>
            </svg>

            <div
                style={{
                    alignSelf: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
				<span
                    className={'complete-profile-form-title'}
                    style={{marginTop: '16px'}}>
					Select your age group
				</span>
                <div className={'complete-profile-flex-row-container'}>
                    <TextInput
                        value={age}
                        onChange={handleAgeChange}
                        placeholder='Input age'
                        readOnly={true}
                        onFocus={() => {
                            setShowAgePopup(true);
                            Mixpanel.track('click_age_group', {
                                event_action: 'clicked',
                                event_page: ' complete_your_profile',
                            });
                        }}
                    />
                    <BottomSheet
                        customStyle={{height: '78%'}}
                        show={showAgePopup}
                        showHeader={false}
                        onHide={setShowAgePopup.bind(null, false)}
                        title={''}
                        content={
                            <div
                                className={'complete-profile-age-body-container'}
                                style={{
                                    width: '100%',
                                    maxWidth: '400px',
                                    overflowY: 'auto',
                                    overflowX: 'hidden',
                                }}>
								<span className={'complete-profile-age-title'}>
									Select your age group
								</span>
                                <div
                                    style={{
                                        display: 'flex',
                                        width: '100%',
                                        justifyContent: 'center',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                    }}>
                                    {OptionsOfAgeGroup?.map((option: any, index: number) => (
                                        <IconWithTitle
                                            selectOptionHandler={selectOptionHandler}
                                            selectedIndex={selectedIndex}
                                            index={index}
                                            title={option.title}
                                            icon={option.icon}
                                            key={index}
                                        />
                                    ))}
                                </div>
                            </div>
                        }
                    />
                </div>
                <span className={'complete-profile-form-title'}>
					Tell us your city for local meet-ups and events
				</span>
                <div className={'complete-profile-flex-row-container'}>
                    <LoadScript
                        googleMapsApiKey='AIzaSyDDQAPp4QTnPgJCttJMN3RhLxoEoC1J6v4'
                        libraries={['places']}>
                        <PlaceInput
                            onSelectPlace={handleSelectPlace}
                            selectedLocation={location}
                        />
                    </LoadScript>
                </div>
                <div className={'complete-profile-flex-row-container'}>
					<span
                        className={'complete-profile-form-title'}
                        style={{width: '70%'}}>
						Get latest updates and reminders on your email
					</span>
                    <span className={'optional-field-container'}>*optional</span>
                </div>

                <TextInput
                    value={email}
                    onChange={handleEmailChange}
                    placeholder='Enter your email'
                    onFocus={() => {
                        setIsKeyboardOpen(true);
                        Mixpanel.track('click_email', {
                            event_action: 'clicked',
                            event_page: ' complete_your_profile',
                        });
                    }}
                    onBlur={() => setIsKeyboardOpen(false)}
                />

                <PrimaryButton
                    textStyle={{
                        color: '#FFF',
                        textAlign: 'center',
                        fontFeatureSettings: "'dlig' on",
                        fontFamily: 'Gordita-Medium',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: 500,
                        lineHeight: '24px', // 150%
                    }}
                    isSticky={true}
                    className={'complete-profile-cta'}
                    onClick={onCompleteProfileHandler}>
                    {'Let the Journey Begin'}
                </PrimaryButton>
            </div>
            <ToastContainer/>
        </div>
    );
}

export default CompleteProfile;
